import apiClient from './client';

export const campaignsApi = {
  // Campaigns
  getAll(params = {}) {
    return apiClient.get('/campaigns', params);
  },

  getById(id) {
    return apiClient.get(`/campaigns/${id}`);
  },

  create(data) {
    return apiClient.post('/campaigns', data);
  },

  update(id, data) {
    return apiClient.put(`/campaigns/${id}`, data);
  },

  delete(id) {
    return apiClient.delete(`/campaigns/${id}`);
  },

  // Advertisers
  getAdvertisers() {
    return apiClient.get('/campaigns/advertisers');
  },

  createAdvertiser(data) {
    return apiClient.post('/campaigns/advertisers', data);
  },

  // Ads
  getAllAds(params = {}) {
    return apiClient.get('/ads', params);
  },

  getAds(campaignId, params = {}) {
    return apiClient.get(`/campaigns/${campaignId}/ads`, params);
  },

  createAd(campaignId, formData) {
    return apiClient.upload(`/campaigns/${campaignId}/ads`, formData);
  },

  updateAd(campaignId, adId, data) {
    // If data is FormData (has a file), use multipart upload with PUT
    if (data instanceof FormData) {
      return apiClient.upload(`/campaigns/${campaignId}/ads/${adId}`, data, 'PUT');
    }
    return apiClient.put(`/campaigns/${campaignId}/ads/${adId}`, data);
  },

  deleteAd(campaignId, adId) {
    return apiClient.delete(`/campaigns/${campaignId}/ads/${adId}`);
  },

  duplicateAd(campaignId, adId) {
    return apiClient.post(`/campaigns/${campaignId}/ads/${adId}/duplicate`);
  },
};

export default campaignsApi;
